import purchaseType from '$modules/purchaseType/routes'
import payment from '$modules/payment/routes'
import paymentMethod from '$modules/paymentMethod/routes'
import fundAccount from '$modules/fundAccount/routes'
import fundAccountType from '$modules/fundAccountType/routes'
import eventDiscountPurchase from '$modules/eventDiscountPurchase/routes'
import sponsorshipPurchase from '$modules/sponsorshipPurchase/routes'

export default [
  {
    path: 'purchase',
    meta: {
      title: 'Purchases',
      auth: ['Admin', 'Super Admin'],
      hidden: false,
      icon: 'attach_money'
    },
    component: () => import('./pages/index'),
    redirect: 'purchase/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'purchase',
          icon: 'playlist_add_check',
          hidden: false
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'purchase',
          icon: 'mode_edit',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Add',
          resource: 'purchase',
          icon: 'add_circle_outline',
          hidden: false
        },
        component: () => import('./pages/add')
      }
    ].concat(purchaseType, payment, paymentMethod, fundAccount, fundAccountType, eventDiscountPurchase, sponsorshipPurchase)
  }
]
